import { Link } from 'react-router-dom';

const highlights = [
  { label: 'Investment Required', value: '₹8–9 Lakhs', sub: 'Initial Business Setup', icon: 'ri-funds-line' },
  { label: 'Equity Offered', value: '10–12%', sub: 'Strategic Partnership', icon: 'ri-pie-chart-2-line' },
  { label: 'Products Portfolio', value: '9+', sub: 'Across 5 Categories', icon: 'ri-store-2-line' },
  { label: 'Growth Target', value: 'Pan India', sub: 'Regional → National → Export', icon: 'ri-global-line' },
];

const phases = [
  { phase: 'Regional', icon: 'ri-map-pin-line', desc: 'Local Market' },
  { phase: 'National', icon: 'ri-map-2-line', desc: 'Pan India' },
  { phase: 'Export', icon: 'ri-global-line', desc: 'International' },
];

const skills = ['Product Development', 'Manufacturing Setup', 'Quality Control', 'Creative Branding'];

export default function InvestorSection() {
  return (
    <section style={{ background: 'linear-gradient(to bottom, #faf7f2, #f5ede0)' }} className="py-16 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20 max-w-6xl mx-auto">

        {/* ── Section Header ── */}
        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="h-px flex-1 max-w-[80px]" style={{ background: '#c9a96e' }}></div>
          <i className="ri-seedling-line text-base" style={{ color: '#c9a96e' }}></i>
          <h2
            className="font-bold text-center px-2"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.6rem', color: '#2c1a0e' }}
          >
            Invest in Faasley
          </h2>
          <i className="ri-seedling-line text-base" style={{ color: '#c9a96e' }}></i>
          <div className="h-px flex-1 max-w-[80px]" style={{ background: '#c9a96e' }}></div>
        </div>

        <p className="text-center text-sm mb-3" style={{ color: '#7a4f2a' }}>
          Be part of India's next premium food brand — authentic taste, hygienic packaging, and a vision to go global.
        </p>

        {/* Decorative divider */}
        <div className="flex items-center justify-center gap-2 mb-12">
          <div className="h-px w-24" style={{ background: '#e8d5b7' }}></div>
          <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#c9a96e' }}></div>
          <div className="h-px w-24" style={{ background: '#e8d5b7' }}></div>
        </div>

        {/* ── MAIN GRID ── */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-start">

          {/* LEFT: Investment details */}
          <div className="space-y-7">

            {/* Highlight stats */}
            <div className="grid grid-cols-2 gap-4">
              {highlights.map((h) => (
                <div
                  key={h.label}
                  className="rounded-xl p-5"
                  style={{ background: '#faf7f2', border: '1px solid #e8d5b7' }}
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-full mb-3" style={{ background: '#f5ede0' }}>
                    <i className={`${h.icon} text-sm`} style={{ color: '#c9a96e' }}></i>
                  </div>
                  <p className="text-[10px] font-bold uppercase tracking-wider mb-1" style={{ color: '#c9a96e' }}>{h.label}</p>
                  <p
                    className="font-bold text-xl mb-0.5"
                    style={{ fontFamily: "'Playfair Display', serif", color: '#2c1a0e' }}
                  >
                    {h.value}
                  </p>
                  <p className="text-xs" style={{ color: '#7a4f2a' }}>{h.sub}</p>
                </div>
              ))}
            </div>

            {/* Growth Vision */}
            <div className="rounded-xl p-6" style={{ background: '#faf7f2', border: '1px solid #e8d5b7' }}>
              <p
                className="font-bold mb-5 text-sm"
                style={{ fontFamily: "'Playfair Display', serif", color: '#2c1a0e' }}
              >
                Growth Vision
              </p>
              <div className="flex items-center gap-3">
                {phases.map((item, i) => (
                  <div key={item.phase} className="flex items-center gap-3 flex-1">
                    <div className="text-center flex-1">
                      <div
                        className="w-11 h-11 rounded-full flex items-center justify-center mx-auto mb-2"
                        style={{ background: '#f5ede0', border: '1px solid #e8d5b7' }}
                      >
                        <i className={`${item.icon} text-base`} style={{ color: '#c9a96e' }}></i>
                      </div>
                      <p className="font-semibold text-xs" style={{ color: '#2c1a0e' }}>{item.phase}</p>
                      <p className="text-[10px]" style={{ color: '#7a4f2a' }}>{item.desc}</p>
                    </div>
                    {i < 2 && (
                      <i className="ri-arrow-right-line text-sm flex-shrink-0" style={{ color: '#c9a96e' }}></i>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Why Invest */}
            <div className="rounded-xl p-6" style={{ background: '#faf7f2', border: '1px solid #e8d5b7' }}>
              <p
                className="font-bold mb-4 text-sm"
                style={{ fontFamily: "'Playfair Display', serif", color: '#2c1a0e' }}
              >
                Why Partner with Faasley?
              </p>
              <ul className="space-y-2.5">
                {[
                  'Authentic, homemade-style products with strong market demand',
                  'Hygienic manufacturing with premium packaging standards',
                  'Experienced founder with clear business roadmap',
                  'Multiple revenue streams across 5 product categories',
                  'Scalable model from regional to national to export markets',
                ].map((point) => (
                  <li key={point} className="flex items-start gap-2.5 text-sm" style={{ color: '#5c3d1e' }}>
                    <span
                      className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0"
                      style={{ background: '#c9a96e' }}
                    ></span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-3">
              <Link
                to="/investors"
                className="inline-flex items-center gap-2 font-semibold px-7 py-3 rounded-md text-sm transition-all whitespace-nowrap"
                style={{ background: '#3b2010', color: '#faf7f2' }}
              >
                View Full Proposal
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 font-medium px-7 py-3 rounded-md text-sm transition-all whitespace-nowrap"
                style={{ border: '1px solid #c9a96e', color: '#3b2010', background: 'transparent' }}
              >
                Schedule a Meeting
              </Link>
            </div>
          </div>

          {/* RIGHT: Founder card */}
          <div>
            <div
              className="rounded-2xl overflow-hidden"
              style={{ border: '1px solid #e8d5b7' }}
            >
              {/* Photo */}
              <div className="relative overflow-hidden" style={{ height: '380px' }}>
                <img
                  src="https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/5cb346ab-a7f1-4cf6-953f-cf38d742223f_Kamini.jpg?v=7ff1f630b615292716d05c68d8042a2b"
                  alt="Kamini Thakur – Founder & CEO"
                  className="w-full h-full object-cover object-top"
                />
                <div
                  className="absolute inset-0"
                  style={{ background: 'linear-gradient(to top, rgba(44,26,14,0.7) 0%, transparent 55%)' }}
                ></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-xs font-bold uppercase tracking-widest mb-1" style={{ color: '#c9a96e' }}>
                    Founder &amp; Visionary
                  </p>
                  <h3
                    className="font-bold text-2xl"
                    style={{ fontFamily: "'Playfair Display', serif", color: '#faf7f2' }}
                  >
                    Kamini Thakur
                  </h3>
                </div>
              </div>

              {/* Quote + skills */}
              <div className="p-6" style={{ background: '#faf7f2' }}>
                <blockquote
                  className="text-sm italic leading-relaxed mb-5 pl-4"
                  style={{ color: '#5c3d1e', borderLeft: '2px solid #c9a96e', fontFamily: "'Playfair Display', serif" }}
                >
                  "Faasley एक premium food brand होगा जो hygienic, homemade style और authentic taste वाले products बनाएगा।"
                </blockquote>

                {/* Divider */}
                <div className="flex items-center gap-2 mb-5">
                  <div className="h-px flex-1" style={{ background: '#e8d5b7' }}></div>
                  <i className="ri-flower-line text-xs" style={{ color: '#c9a96e' }}></i>
                  <div className="h-px flex-1" style={{ background: '#e8d5b7' }}></div>
                </div>

                <div className="grid grid-cols-2 gap-2.5">
                  {skills.map((skill) => (
                    <div key={skill} className="flex items-center gap-2 text-xs" style={{ color: '#5c3d1e' }}>
                      <i className="ri-check-line text-sm" style={{ color: '#c9a96e' }}></i>
                      {skill}
                    </div>
                  ))}
                </div>

                {/* Decorative bottom */}
                <div className="flex items-center gap-2 mt-5">
                  <div className="h-px flex-1" style={{ background: '#e8d5b7' }}></div>
                  <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#c9a96e' }}></div>
                  <div className="h-px flex-1" style={{ background: '#e8d5b7' }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Bottom tagline ── */}
        <div className="flex items-center gap-4 mt-14 mb-6">
          <div className="h-px flex-1" style={{ background: '#e8d5b7' }}></div>
          <i className="ri-flower-line text-base" style={{ color: '#c9a96e' }}></i>
          <div className="h-px flex-1" style={{ background: '#e8d5b7' }}></div>
        </div>

        <div className="text-center">
          <p
            className="font-bold mb-5"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.1rem', color: '#2c1a0e' }}
          >
            Build Something Meaningful Together
          </p>
          <Link
            to="/investors"
            className="inline-flex items-center gap-2 font-semibold px-8 py-3 rounded-md text-sm transition-all whitespace-nowrap"
            style={{ background: '#3b2010', color: '#faf7f2' }}
          >
            Explore Partnership
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

      </div>
    </section>
  );
}
